import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import reactjs from '../assets/reactjs.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import wordpress from '../assets/wordpress.png';
import bootstrap from '../assets/bootstrap.png';

import about02 from '../assets/about02.png';
import digitalMarketing from '../assets/digitalMarketing.svg';
import seo from '../assets/seo.svg';
import consulting from '../assets/consulting.svg';

import profile from '../assets/profile.png';
import header_pic from '../assets/header_pic.svg';
import person from '../assets/person.png';
import circle from '../assets/circle.svg';
import logo from '../assets/WEBSTUDIO.png';
import logo_text from '../assets/webstudio-text.png';
import gym_fitness from '../assets/GymFitness.png';
import webstudio1 from '../assets/Webstudio1.png';
import foodOrder from '../assets/foodOrder.png';
import HooBank from '../assets/HooBank.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  reactjs,
  redux,
  bootstrap,
  sass,
  typescript,
  vue,
  about02,
  digitalMarketing,
  seo,
  consulting,
  profile,
  header_pic,
  person,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  wordpress,
  logo_text,
  gym_fitness,
  webstudio1,
  foodOrder,
  HooBank
};